import React, { useMemo } from 'react';
import { Card } from './TagDashParts';
import { zeroPieceCount, openLineFix } from './TagLineFixDialog';

const TH = 'px-2 py-1.5 text-left font-semibold';

// Unsold tags with lines that have carats but 0 pieces; a row opens the correction screen.
export function TagZeroPiecesWidget({ items }) {
  const rows = useMemo(() => items.filter((j) => !j.sold).map((j) => ({ ...j, zero: zeroPieceCount(j) })).filter((j) => j.zero).sort((a, b) => b.zero - a.zero), [items]);
  const exp = () => ({
    head: ['Jewellery no.', 'Type', 'Lines with 0 pieces'],
    rows: rows.map((r) => [r.jewellery_no, r.jewellery_type || '', r.zero]),
    foot: rows.length ? ['Total', `${rows.length} tag(s)`, rows.reduce((t, r) => t + r.zero, 0)] : undefined,
  });
  return (
    <Card title="Tags with 0 pieces" sub={`${rows.length} tag${rows.length === 1 ? '' : 's'}`} testid="tagws-zero-pcs-widget" exp={exp}>
      <p className="-mt-1 mb-3 text-xs text-muted-foreground">Unsold tags where a printed line has carats but 0 pieces. Click a row to correct the pieces. The dashboard dates and filters don&apos;t apply here.</p>
      {!rows.length ? <p className="py-8 text-center text-xs text-muted-foreground" data-testid="tagws-zero-pcs-empty">No tags with 0 pieces.</p> : (
        <div className="max-h-96 overflow-auto rounded-xl border border-border">
          <table className="w-full text-xs" data-testid="tagws-zero-pcs-table">
            <thead className="sticky top-0 bg-secondary text-[length:calc(var(--fs,1)*0.65625rem)] uppercase tracking-wider text-muted-foreground"><tr><th className={TH}>Jewellery no.</th><th className={TH}>Type</th><th className={`${TH} text-right`}>Lines with 0 pcs</th></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id} onClick={() => openLineFix(r.id)} className="cursor-pointer border-t border-border/60 hover:bg-secondary/60" data-testid="tagws-zero-pcs-row">
                <td className="px-2 py-1.5 font-mono font-semibold text-red-700">{r.jewellery_no}</td><td className="px-2 py-1.5">{r.jewellery_type || '—'}</td>
                <td className="px-2 py-1.5 text-right font-mono font-semibold">{r.zero}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
